import { db } from "../../../../mp-database"
import markGUAsAsNeedingUpdateAll from "../../assessment/markGUAsAsNeedingUpdateAll"
import assignTeacherToStudents from "../../assessment/assignTeacherToStudents"
import markGroupCPsNeedingUpdate from "../../assessment/markGroupCPsNeedingUpdate"
import updateStudentLessonsByClass from "../../studentCourseProgress/updateStudentLessonsByClass"

export default async function assignStudentsToClass(
  students,
  record,
  notInClass,
  year,
  courseId
) {
  if (!students?.length) return

  const batch = db.batch()
  const studentRefs = students.map(student =>
    db.collection("students").doc(student.id)
  )
  const classRef = db.collection("classes").doc(record.id)
  const classKey = students.map(student => `students.${student.id}`)
  const studentKey = `classes.${record.id}`
  const teacherKey = `teachers.${record.teacher}`
  const collStudentKey = `classIds.${record.id}`
  const collTeacherKey = `teacherIds.${record.teacher}`
  let teacherStatus = ""

  if (!notInClass) {
    teacherStatus = await assignTeacherToStudents(record, students)
  } else {
    studentRefs.forEach(ref => {
      batch.update(ref, { [teacherKey]: !!notInClass })
    })
  }

  classKey.forEach(key => {
    batch.update(classRef, { [key]: !!notInClass })
  })
  studentRefs.forEach(ref => {
    batch.update(ref, { [studentKey]: !!notInClass })
  })

  const p1 = batch.commit()
  await Promise.all([p1])
    .then(d => {})
    .catch(err => console.log("batch", err))

  const batchUAupdates = students.map(async student =>
    addUserAssessments(
      student.id,
      Number(year || record.schoolYear),
      collTeacherKey,
      collStudentKey,
      notInClass,
      teacherStatus
    )
  )

  await Promise.all([...batchUAupdates])
    .then(d => {})
    .catch(err => console.log("batchUAupdates", err))

  const batchCollectionsUpdates = students.map(student =>
    addUACollections(
      student.id,
      Number(year || record.schoolYear),
      collTeacherKey,
      collStudentKey,
      notInClass,
      teacherStatus
    )
  )
  await Promise.all([...batchCollectionsUpdates])
    .then(d => {})
    .catch(err => console.log("batchCollectionsUpdates", err))

  const batchCPCollectionsUpdates = students.map(student =>
    addCPCollections(
      student.id,
      collTeacherKey,
      collStudentKey,
      notInClass,
      teacherStatus
    )
  )

  await Promise.all([...batchCPCollectionsUpdates])
    .then(d => {})
    .catch(err => console.log("batchCPCollectionsUpdates", err))

  const p2 = students.map(student =>
    markGUAsAsNeedingUpdateAll(student, record, year)
  )
  await Promise.all([p2])
    .then(d => {})
    .catch(err => console.log("p2", err))

  const p3 = students.map(student =>
    markGroupCPsNeedingUpdate(student, record, courseId)
  )
  return Promise.all([p3])
}

async function addUserAssessments(
  userId,
  year,
  teacherKey,
  classKey,
  notInClass,
  teacherStatus
) {
  const batch = db.batch()
  const querySnapshot = await db
    .collection("userAssessments")
    .where("userId", "==", `${userId}`)
    // .where("year", "==", year)
    .get()

  querySnapshot.forEach(doc => {
    if (!notInClass) {
      if (teacherStatus[userId]) {
        batch.update(doc.ref, { [teacherKey]: true })
      } else {
        batch.update(doc.ref, { [teacherKey]: false })
      }
    } else {
      batch.update(doc.ref, { [teacherKey]: !!notInClass })
    }
    batch.update(doc.ref, { [classKey]: !!notInClass })
  })
  await Promise.all([batch.commit()])
    .then(d => {})
    .catch(err => console.log("addUserAssessments-Batch", err))
}

async function addUACollections(
  userId,
  year,
  teacherKey,
  classKey,
  notInClass,
  teacherStatus
) {
  const collections = [
    "answersByItem",
    "scoringByItem",
    "scoringByNode",
    "scoringBySubtest",
    "scoringByTest"
  ]
  const promises = collections.map(async collection => {
    const querySnapshot = await db
      .collection(collection)
      .where(
        collection === "answersByItem" ? "studentId" : "userId",
        "==",
        `${userId}`
      )
      // .where("year", "==", year)
      .get()
    const batch = db.batch()
    querySnapshot.forEach(doc => {
      if (!notInClass) {
        if (teacherStatus[userId]) {
          batch.update(doc.ref, { [teacherKey]: true })
        } else {
          batch.update(doc.ref, { [teacherKey]: false })
        }
      } else {
        batch.update(doc.ref, { [teacherKey]: !!notInClass })
      }
      batch.update(doc.ref, { [classKey]: !!notInClass })
    })
    await Promise.all([batch.commit()])
      .then(d => {})
      .catch(err => console.log("addUACollections-Batch", err))
  })
  return Promise.all(promises)
}

async function addCPCollections(
  userId,
  teacherKey,
  classKey,
  notInClass,
  teacherStatus
) {
  const collections = [
    "courses_students",
    "subcourses_students",
    "sections_students",
    "lessons_students",
    "items_students",
    "itemBanks_students",
    "nodes_students",
    "nodes_students_current",
    "nodes_students_courses_current"
  ]
  await updateStudentLessonsByClass(classKey, userId, notInClass)
  const promises = collections.map(async collection => {
    const querySnapshot = await db
      .collection(collection)
      .where("studentId", "==", userId)
      .get()
    const batch = db.batch()
    querySnapshot.forEach(doc => {
      if (!notInClass) {
        if (teacherStatus[userId]) {
          batch.update(doc.ref, { [teacherKey]: true })
        } else {
          batch.update(doc.ref, { [teacherKey]: false })
        }
      } else {
        batch.update(doc.ref, { [teacherKey]: !!notInClass })
      }
      batch.update(doc.ref, { [classKey]: !!notInClass })
    })
    await Promise.all([batch.commit()])
      .then(d => {})
      .catch(err => console.log("addCPCollections-Batch", err))
  })
  return Promise.all(promises)
}
